import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';

const SkillDevelopment = () => {
    return (
        <section>
            <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
                <Helmet>
                    <title>LMP Student Skill Development Program </title>
                    <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
                </Helmet>
                <section className='bg-gray-200 w-full py-2'>
                    <div className='text-sm flex items-center gap-2 py-3 place-content-center'>
                        <Link to="/" className="hover:text-green-600 font-semibold">Home</Link>
                        <MdKeyboardDoubleArrowRight className='text-green-600' />
                        <Link to="/" className="hover:text-green-600 font-semibold">MIJSC Programs</Link>
                        <MdKeyboardDoubleArrowRight className='text-green-600' />
                        <Link to="/" className="hover:text-green-600 font-semibold">Student Skill Development Program</Link>
                    </div>
                </section>

                
                <div className='w-full text-justify md:flex md:mx-10 md:px-0 px-3'>
                    <section className='md:w-[94%] h-fit  mb-5 mt-10' >
                        <h1 className='mb-10 text-[#119445] md:text-4xl text-2xl font-semibold uppercase text-left'>LMP Student Development <br></br>Program</h1>
                        <h2 className='md:text-2xl text-lg text-[#119445] font-semibold'>Phase - 2</h2>
                         <p className='pb-3'> <b> LMP Student Skill Development Program </b> </p> 
                        <p className='text-gray-500'><b> Facilitator : Engineering College </b> </p>
                        <p className='text-gray-500'>Timeline FLMP & ALMP : Recommended in 5th & 6th Sem </p>
                        <p className='text-gray-500  pt-3'> Timeline Internships & Projects : 7th & 8th Sem @ Industry </p>
                        <p className='text-gray-500 my-1'> Mode of Delivery: Self Learning (MOOCs) + Faculty Interventions (Classroom Learning) + Industry Application Projects (Offline) </p>
                        <p className='text-gray-500 my-1'> Outcome: Students trained in State - of - Art Lean Practices </p>
                        <p className='text-gray-500 my-1'> Key Benefits : Students become industry ready </p>
                    </section>
                </div>

                <div className="w-[94%] text-justify md:mx-10 mx-2 md:mt-2">
                    <div className="w-full overflow-x-auto">
                        <table className="min-w-[700px] w-full border border-gray-300 text-sm text-left">
                            <tbody>
                                {/* Header row 1 */}
                                <tr className="bg-gray-100">
                                    <th
                                        rowSpan={2}
                                        className="border border-gray-300 px-4 py-3 text-center text-lg text-green-600 font-semibold"
                                    >
                                        Course
                                    </th>
                                    <th
                                        rowSpan={2}
                                        className="border border-gray-300 px-4 py-3 text-center text-lg text-green-600 font-semibold"
                                    >
                                        Content
                                    </th>
                                    <th
                                        colSpan={4}
                                        className="border border-gray-300 px-4 py-3 text-center text-lg text-green-600 font-semibold"
                                    >
                                        Semesters
                                    </th>
                                </tr>

                                {/* Header row 2 */}
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 px-4 py-2 text-center">5</th>
                                    <th className="border border-gray-300 px-4 py-2 text-center">6</th>
                                    <th className="border border-gray-300 px-4 py-2 text-center">7</th>
                                    <th className="border border-gray-300 px-4 py-2 text-center">8</th>
                                </tr>

                                {/* Row 1 */}
                                <tr>
                                    <td className="border border-gray-300 px-4 py-3">
                                        Foundations of Lean Manufacturing Practices
                                    </td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        6 Modules of Self Learning + Faculty Interventions + Industry Application Projects
                                    </td>
                                    <td className="border border-gray-300 bg-green-600"></td>
                                    <td className="border border-gray-300"></td>
                                    <td className="border border-gray-300"></td>
                                    <td className="border border-gray-300"></td>
                                </tr>

                                {/* Row 2 */}
                                <tr>
                                    <td className="border border-gray-300 px-4 py-3">
                                        Advanced Lean Manufacturing Practices
                                    </td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        6 Modules of Self Learning + Faculty Interventions + Industry Application Projects
                                    </td>
                                    <td className="border border-gray-300"></td>
                                    <td className="border border-gray-300 bg-green-600"></td>
                                    <td className="border border-gray-300"></td>
                                    <td className="border border-gray-300"></td>
                                </tr>

                                {/* Row 3 */}
                                <tr>
                                    <td className="border border-gray-300 px-4 py-3">
                                        Internships & Projects
                                    </td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        Industry Projects with a focus on lean manufacturing tools and techniques
                                    </td>
                                    <td className="border border-gray-300"></td>
                                    <td className="border border-gray-300"></td>
                                    <td className="border border-gray-300 bg-green-600"></td>
                                    <td className="border border-gray-300 bg-green-600"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </section>
    )
}

export default SkillDevelopment
